// Import the functions you need from the SDKs you need
import { getApp,getApps,initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getFirestore}from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
const firebaseConfig = {
  apiKey: "AIzaSyAabwl23uKFj3Gifc001VXrUP6j0oweRBU",
  authDomain: "doc-nexify.firebaseapp.com",
  databaseURL: "https://doc-nexify-default-rtdb.firebaseio.com",
  projectId: "doc-nexify",
  storageBucket: "doc-nexify.appspot.com",
  messagingSenderId: "598767342465",
  appId: "1:598767342465:web:a9a8ec2d86813874b80e80",
  measurementId: "G-CF2E78JFYW"
};

// Initialize Firebase
const app = getApps.length>0 ? getApp():initializeApp(firebaseConfig);
const firestore=getFirestore(app);
const storage=getStorage(app)
const auth = getAuth(app);

export {auth,app,firestore,storage}